import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_NOTIFICATIONS').plugin(axiosPlugin, {template: "array"});

let fetchUserNotificationsAction = redux.fetchActionGet();

let markUserNotificationOpenAction = redux.fetchActionUpdate('SET_OPEN', {
    reducer: (state, action) => ({
        ...state
    }),
    failReducer: (state, action) => ({
        ...state
    }),
    successReducer: (state, action) => {
        let data = state.data.map(item => {
            if (item._id === action.payload._id) {
                item.open = true;
            }
            return item;
        });
        return {
            ...state,
            data
        }
    },
});

let markAllUserNotificationsOpenAction = redux.fetchActionUpdate('SET_OPEN', {
    reducer: (state, action) => ({
        loading: true,
        ...state
    }),
    failReducer: (state, action) => ({
        loading: false,
        ...state
    }),
    successReducer: (state, action) => {
        let data = state.data.map(item => {
            item.open = true;
            return item;
        });
        return {
            ...state,
            loading: false,
            data
        }
    },
});

export const TYPES = redux.types;

export const fetchUserNotifications = (query = {}, more = false) => fetchUserNotificationsAction(`/users/me/notifications?${queryString.stringify(query)}`, null, {more});
export const markUserNotificationOpen = (notificationId) => markUserNotificationOpenAction(`/users/me/notifications/open/${notificationId}`);
export const markAllUserNotificationsOpen = (notificationId) => markAllUserNotificationsOpenAction(`/users/me/notifications/open`);
export const resetUserNotifications = () => redux.actions.reset();

export const userNotifications = redux.reducer();